export const CITY_LIST = [
    {
        text: '武汉市',
        value: '420100',
        children: [
            { text: '江岸区', value: '420102' },
            { text: '江汉区', value: '420103' },
            { text: '硚口区', value: '420104' },
            { text: '汉阳区', value: '420105' },
            { text: '武昌区', value: '420106' },
            { text: '青山区', value: '420107' },
            { text: '洪山区', value: '420111' },
            { text: '东西湖区', value: '420112' },
            { text: '汉南区', value: '420113' },
            { text: '蔡甸区', value: '420114' },
            { text: '江夏区', value: '420115' },
            { text: '黄陂区', value: '420116' },
            { text: '新洲区', value: '420117' }
        ]
    },
    {
        text: '黄石市',
        value: '420200',
        children: [
            { text: '黄石港区', value: '420202' },
            { text: '西塞山区', value: '420203' },
            { text: '下陆区', value: '420204' },
            { text: '铁山区', value: '420205' },
            { text: '大冶市', value: '420281' },
            { text: '阳新县', value: '420222' }
        ]
    },
    {
        text: '十堰市',
        value: '420300',
        children: [
            { text: '茅箭区', value: '420302' },
            { text: '张湾区', value: '420303' },
            { text: '郧阳区', value: '420304' },
            { text: '丹江口市', value: '420381' },
            { text: '郧西县', value: '420322' },
            { text: '竹山县', value: '420323' },
            { text: '竹溪县', value: '420324' },
            { text: '房县', value: '420325' }
        ]
    },
    {
        text: '宜昌市',
        value: '420500',
        children: [
            { text: '西陵区', value: '420502' },
            { text: '伍家岗区', value: '420503' },
            { text: '点军区', value: '420504' },
            { text: '猇亭区', value: '420505' },
            { text: '夷陵区', value: '420506' },
            { text: '宜都市', value: '420581' },
            { text: '当阳市', value: '420582' },
            { text: '枝江市', value: '420583' },
            { text: '远安县', value: '420525' },
            { text: '兴山县', value: '420526' },
            { text: '秭归县', value: '420527' },
            { text: '长阳土家族自治县', value: '420528' },
            { text: '五峰土家族自治县', value: '420529' }
        ]
    },
    {
        text: '襄阳市',
        value: '420600',
        children: [
            { text: '襄城区', value: '420602' },
            { text: '樊城区', value: '420606' },
            { text: '襄州区', value: '420607' },
            { text: '老河口市', value: '420682' },
            { text: '枣阳市', value: '420683' },
            { text: '宜城市', value: '420684' },
            { text: '南漳县', value: '420624' },
            { text: '谷城县', value: '420625' },
            { text: '保康县', value: '420626' }
        ]
    },
    {
        text: '鄂州市',
        value: '420700',
        children: [
            { text: '梁子湖区', value: '420702' },
            { text: '华容区', value: '420703' },
            { text: '鄂城区', value: '420704' }
        ]
    },
    {
        text: '荆门市',
        value: '420800',
        children: [
            { text: '东宝区', value: '420802' },
            { text: '掇刀区', value: '420804' },
            { text: '钟祥市', value: '420881' },
            { text: '京山市', value: '420882' },
            { text: '沙洋县', value: '420822' }
        ]
    },
    {
        text: '孝感市',
        value: '420900',
        children: [
            { text: '孝南区', value: '420902' },
            { text: '应城市', value: '420981' },
            { text: '安陆市', value: '420982' },
            { text: '汉川市', value: '420984' },
            { text: '孝昌县', value: '420921' },
            { text: '大悟县', value: '420922' },
            { text: '云梦县', value: '420923' }
        ]
    },
    {
        text: '荆州市',
        value: '421000',
        children: [
            { text: '沙市区', value: '421002' },
            { text: '荆州区', value: '421003' },
            { text: '石首市', value: '421081' },
            { text: '洪湖市', value: '421083' },
            { text: '松滋市', value: '421087' },
            { text: '公安县', value: '421022' },
            { text: '监利市', value: '421088' },
            { text: '江陵县', value: '421024' }
        ]
    },
    {
        text: '黄冈市',
        value: '421100',
        children: [
            { text: '黄州区', value: '421102' },
            { text: '麻城市', value: '421181' },
            { text: '武穴市', value: '421182' },
            { text: '团风县', value: '421121' },
            { text: '红安县', value: '421122' },
            { text: '罗田县', value: '421123' },
            { text: '英山县', value: '421124' },
            { text: '浠水县', value: '421125' },
            { text: '蕲春县', value: '421126' },
            { text: '黄梅县', value: '421127' }
        ]
    },
    {
        text: '咸宁市',
        value: '421200',
        children: [
            { text: '咸安区', value: '421202' },
            { text: '赤壁市', value: '421281' },
            { text: '嘉鱼县', value: '421221' },
            { text: '通城县', value: '421222' },
            { text: '崇阳县', value: '421223' },
            { text: '通山县', value: '421224' }
        ]
    },
    {
        text: '随州市',
        value: '421300',
        children: [
            { text: '曾都区', value: '421303' },
            { text: '广水市', value: '421381' },
            { text: '随县', value: '421321' }
        ]
    },
    {
        text: '恩施土家族苗族自治州',
        value: '422800',
        children: [
            { text: '恩施市', value: '422801' },
            { text: '利川市', value: '422802' },
            { text: '建始县', value: '422822' },
            { text: '巴东县', value: '422823' },
            { text: '宣恩县', value: '422825' },
            { text: '咸丰县', value: '422826' },
            { text: '来凤县', value: '422827' },
            { text: '鹤峰县', value: '422828' }
        ]
    },
    {
        text: '仙桃市',
        value: '429004',
        children: [{ text: '仙桃市', value: '429004' }]
    },
    {
        text: '潜江市',
        value: '429005',
        children: [{ text: '潜江市', value: '429005' }]
    },
    {
        text: '天门市',
        value: '429006',
        children: [{ text: '天门市', value: '429006' }]
    },
    {
        text: '神农架林区',
        value: '429021',
        children: [{ text: '神农架林区', value: '429021' }]
    }
];
